import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DK: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologi',
  components_header_media_multi_content_2: 'Meditation',
  components_header_media_multi_content_3: 'Kærlighed',
  components_header_text1: 'Guider',
  components_header_text2: 'Blog',
  hero_text: 'Find klarhed, balance og forbindelse.',
  hero_button_text: 'Start din rejse',
  components_ressources_subheader_text: 'Tips og inspiration',
  components_ressources_span_text: 'Den samler personlige astrologiske indsigter, beroligende meditationspraksis og tankevækkende kærlighedsvejledning for at støtte selvopdagelse, følelsesmæssig balance og dybere forbindelse.',
  components_ressources_card_1_title: 'Meditationstips',
  components_ressources_card_1_text: 'Hurtig guide til bedre ro, vejrtrækning og fokus.',
  components_ressources_card_2_title: 'Kærlighedsvejledning',
  components_ressources_card_2_text: 'Enkle tips til at opbygge stærkere forbindelser og følelsesmæssig balance.',
  components_ressources_link: 'Opdag mere',
  components_notes_and_google_title_1: 'Find klarhed',
  components_notes_and_google_title_2: 'Indre ro',
  components_notes_and_google_title_3: 'Hjerteforbindelse',
  media_content_section_multi_1_subheader_text: 'Vores podcast',
  media_content_section_multi_2_subheader_text: 'Vores meditationer',
  media_content_section_multi_3_subheader_text: 'Ærlig snak om kosmisk romance',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energiboost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Fundamenter',
  page_media_content_menu_spirituality: 'Spiritualitet',
  page_media_content_menu_tarot: 'Tarotkort',
  page_media_content_menu_psychology: 'Psykologi',
  page_media_content_menu_trends: 'Tendenser',
  page_media_content_menu_compatibility: 'Kompatibilitet',
  page_media_content_menu_love: 'Kærlighed',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artikler og indsigt',
  text2_section_button_more: 'Indlæs mere',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: 'Kosmisk viden til daglig justering',
  components_text1_span_text: 'Bliv afstemt med universets rytmer: Udforsk en kurateret samling af dybdegående astrologiske og meditative guider designet til at vække indre klarhed, uddybe selvbevidsthed og støtte din rejse mod sjælelig, himmelsk vækst.',
  components_text1_card_1_title: 'Åben for stilheden',
  components_text1_card_1_text: 'Begynd din rejse med grundlæggende meditations- og astrologiguider – ideelt for dem, der søger indre stilhed, kosmiske mønstre og personlig indsigt.',
  components_text1_card_3_title: 'Sind-krop-forbindelsen',
  components_text1_card_3_text: 'Afdæk de dybere lag af din indre verden. Disse guider bevæger sig ud over overfladen for at afsløre mening, følelser og mindfulness-mønstre, der former din oplevelse.',
  components_text1_card_2_title: 'Reflekter og integrer',
  components_text1_card_2_text: 'Fra følelsesmæssige blokeringer til planetariske cyklusser – disse guider tilbyder værktøjer til refleksion, heling og transformation gennem mindful ritualer og astrologisk visdom.',
  components_text1_link: 'Se alle guider',
  components_footer_text: 'Find klarhed, balancer dit sind og få kontakt med mening – dit sted for astrologi, meditation og kærlighed.',
};